'use client';
import { Field, useField } from 'formik';
import { FC } from 'react';
import { cvaClose, cvaCloseIcon, cvaInner, cvaInput, cvaRoot } from './TogglerSimpleStyles';
import IconClose from '/public/icons/close.svg';

interface Props {
  name: string;
  value: string | number;
  title: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TogglerSimple: FC<Props> = ({ name, value, title, onChange }) => {
  const [field] = useField({
    name,
    type: 'checkbox',
    value: value.toString(),
  });
  return (
    <label className={cvaRoot()}>
      <Field
        type={'checkbox'}
        name={name}
        value={value.toString()}
        className={cvaInput()}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          field.onChange(e);
          if (onChange) {
            onChange(e);
          }
        }}
      />
      <span className={cvaInner()}>
        <span className="z-[1] relative">{title}</span>
      </span>
      <div className={cvaClose()}>
        <IconClose className={cvaCloseIcon()} />
      </div>
    </label>
  );
};

export default TogglerSimple;
